import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Mycase.css';

const Mycase = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const visionData = [
    {
      id: 1,
      image: '/images/case/logisticsWarehouse.jpg',
      title: 'Smart Warehouse Management System',
      metrics: 'SLA Dashboard • CI/CD Rollbacks',
      category: 'Logistics & Supply Chain • System Modernization',
      highlights: [
        'React + Node.js Re-architecture',
        'System-Triggered Handoffs',
        'Real-time Ops Dashboard'
      ],
      status: 'Production (Staged → Live)',
      description: 'Consulting + delivery engagement replacing a legacy parcel tracking/dispatch platform with a modern, integrated system and safe release practices.',
      route: '/warehouse-management',
      anchor: 'warehouse-card'
    },
    {
      id: 2,
      image: '/images/case/team.jpg',
      title: 'Graduate Industry Project — AI-Assisted Family Support Platform',
      metrics: 'Multi-Role Delivery • Program Award',
      category: 'Social Impact • Accessibility',
      highlights: [
        'Product/Project Leadership',
        'UI/UX (Figma) & Frontend',
        'Manual + Automated Testing'
      ],
      status: 'Delivered (Program Showcase Recognition)',
      description: 'Web platform supporting parents of autistic children with accessible design and guided resources. Led PM, schedule & scope, UI/UX, frontend, and QA under tight timelines.',
      route: '/graduate-industry-project',
      anchor: 'graduate-card'
    },

    {
      id: 3,
      image: '/images/case/stock.jpg',
      title: 'Quantitative Research & Trading Strategies',
      metrics: '12% Annualised Backtest • EconLit Indexed',
      category: 'Quant Research • Econometrics',
      highlights: ['Cointegration Analysis', 'Threshold Regression', 'Backtesting (Python/R)'],
      status: 'Research & Backtesting',
      description: 'Time-series research: automated data ingestion, hypothesis testing, cointegration-based strategies, threshold-regression commodity modelling, and real-time signal scripts.',
      route: '/quantitative-trading',
      anchor: 'trading-card'
    }

  ];

  // 处理从详情页面返回时的锚点定位
  useEffect(() => {
    if (location.state && location.state.scrollToCard) {
      setTimeout(() => {
        const element = document.getElementById(location.state.scrollToCard);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    }
  }, [location]);

  const handleCardClick = (route) => {
    navigate(route);
  };

  const handleReadMoreClick = (e, route) => {
    e.stopPropagation();
    navigate(route);
  };

  return (
    <section className="mycase-section" id="mycase">
      <div className="mycase-container">
        {/* Header Section */}
        <div className="mycase-header">
          <div className="mycase-badge">Case Studies</div>
          <h2 className="mycase-title">Systems That Drive Results</h2>
          <p className="mycase-subtitle">Transforming complex challenges into scalable, high-impact solutions</p>
        </div>

        {/* Vision Grid */}
        <div className="mycase-grid">
          {visionData.map((visionItem) => (
            <div
              key={visionItem.id}
              id={visionItem.anchor}
              className="mycase-card clickable-card"
              onClick={() => handleCardClick(visionItem.route)}
            >
              <div className="mycase-card-image">
                <img src={visionItem.image} alt={visionItem.title} />
                <div className="mycase-card-status">
                  <span className="status-dot"></span>
                  {visionItem.status}
                </div>
              </div>

              <div className="mycase-card-content">
                <div className="mycase-card-category">{visionItem.category}</div>
                <h3 className="mycase-card-title">{visionItem.title}</h3>
                <div className="mycase-card-metrics">{visionItem.metrics}</div>
                <p className="mycase-card-description">{visionItem.description}</p>

                <div className="mycase-card-highlights">
                  {visionItem.highlights.map((highlight, index) => (
                    <span key={index} className="highlight-tag">
                      {highlight}
                    </span>
                  ))}
                </div>

                <button
                  className="mycase-read-more"
                  onClick={(e) => handleReadMoreClick(e, visionItem.route)}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    color: 'inherit'
                  }}
                >
                  View Case Study
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Mycase;
